import { render } from "./topPracticeGroups.vue?vue&type=template&id=17338272"
import script from "./topPracticeGroups.vue?vue&type=script&lang=js"
export * from "./topPracticeGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__